var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5508 2.91675C12.5508 3.05347 12.5508 3.16284 12.5508 3.29956C12.5508 7.10034 9.67969 11.448 4.40234 11.448C2.76172 11.448 1.25781 10.9832 0 10.1628C0.21875 10.1902 0.4375 10.2175 0.683594 10.2175C2.02344 10.2175 3.25391 9.75269 4.23828 8.98706C2.98047 8.95972 1.91406 8.1394 1.55859 6.99097C1.75 7.01831 1.91406 7.04565 2.10547 7.04565C2.35156 7.04565 2.625 6.99097 2.84375 6.93628C1.53125 6.66284 0.546875 5.5144 0.546875 4.11987V4.09253C0.929688 4.31128 1.39453 4.42065 1.85938 4.448C1.06641 3.92847 0.574219 3.05347 0.574219 2.06909C0.574219 1.52222 0.710938 1.03003 0.957031 0.619873C2.37891 2.34253 4.51172 3.49097 6.89062 3.62769C6.83594 3.40894 6.80859 3.19019 6.80859 2.97144C6.80859 1.3855 8.09375 0.100342 9.67969 0.100342C10.5 0.100342 11.2383 0.428467 11.7852 1.00269C12.4141 0.865967 13.043 0.619873 13.5898 0.291748C13.3711 0.975342 12.9336 1.52222 12.332 1.87769C12.9062 1.823 13.4805 1.65894 13.9727 1.44019C13.5898 2.0144 13.0977 2.50659 12.5508 2.91675Z",
    fill: "#1C2539"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.1ac4916278a0fea3cdb9af152ca590f5.svg";
export { ForwardRef as ReactComponent };